const baseUrlChange = process.env.VUE_APP_BASEURL_CHANGE;

export default {
  // 获取工单列表
  getFeedbackList: `${baseUrlChange}/feedback/list`,
  // 获取工单配置
  getFeedBackConfig: `${baseUrlChange}/feedback/info`,
  // 提交工单
  postFeedBack: `${baseUrlChange}/feedback/commit`,
  // 取消工单
  postCancel: `${baseUrlChange}/feedback/cancel`,
  // 关闭工单
  postFinish: `${baseUrlChange}/feedback/finish`,
  // 确认未解决
  postReopen: `${baseUrlChange}/feedback/reopen`,
  // 回复工单
  postReply: `${baseUrlChange}/feedback/reply`,
};
